import React, { FC, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { scrollToTop } from '../../utils'
import { fetchByDetailProduct } from '../../store/slices/productsSlice'
import { NavLink, useParams } from 'react-router-dom'
import TopBanner from '../../components/TopBanner/TopBanner'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import Loader from '../../components/Loader/Loader'
import { Helmet } from 'react-helmet-async'
import HeroSection from './HeroSection/HeroSection'
import ProductInfoSection from './ProductInfoSection/ProductInfoSection'
import TechnicalSection from './TechnicalSection/TechnicalSection'
import DocumentsSection from './DocumentsSection/DocumentsSection'

const DetailProduct: FC = () => {
    const { id, name } = useParams()
    const dispatch = useAppDispatch()
    const { detail, loading } = useAppSelector(state => state.products)

    useEffect(() => {
        if (id) {
            scrollToTop()
            dispatch(fetchByDetailProduct(Number(id)))
        }
    }, [dispatch, id])

    return (
        <>
            <Helmet>
                <title>{`${detail?.title || name} | Продукция | Phoenix Programs`}</title>

                <meta
                    name="description"
                    content={
                        detail?.description
                            ? detail.description.replace(/[#_*>\n]/g, '').slice(0, 160)
                            : `${detail?.title || name} — продукция компании Phoenix Programs`
                    }
                />

                <link rel="canonical" href={`https://phoenix-programs.ru/products/${id}/${encodeURIComponent(name || '')}`} />

                {/* Open Graph */}
                <meta property="og:type" content="article" />
                <meta property="og:locale" content="ru_RU" />
                <meta property="og:url" content={`https://phoenix-programs.ru/products/${id}/${encodeURIComponent(name || '')}`} />
                <meta property="og:title" content={`${detail?.title || name} | Phoenix Programs`} />
                <meta
                    property="og:description"
                    content={
                        detail?.description
                            ? detail.description.replace(/[#_*>\n]/g, '').slice(0, 160)
                            : `Продукция компании Phoenix Programs`
                    }
                />
                <meta property="og:image" content="https://phoenix-programs.ru/logo192.png" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={`${detail?.title || name} | Phoenix Programs`} />
                <meta
                    name="twitter:description"
                    content={
                        detail?.description
                            ? detail.description.replace(/[#_*>\n]/g, '').slice(0, 160)
                            : `Продукция Phoenix Programs`
                    }
                />
                <meta name="twitter:image" content="https://phoenix-programs.ru/logo192.png" />

                <meta name="robots" content="index, follow" />
            </Helmet>
            {loading && <Loader />}
            <TopBanner title={name} />
            <Breadcrumbs>
                <NavLink to={'/'}>Главная</NavLink>
                /
                <NavLink to={`/products`}>Продукция</NavLink>
                /
                <span>{name}</span>
            </Breadcrumbs>

                {detail && (
                    <div style={{overflow:'hidden'}}>
                        <HeroSection mainImage={detail.main_image} title={detail.title} />
                        <ProductInfoSection
                            aboutText={detail.about_text}
                            icon={detail.about_icon}
                            featuresDescription={detail.features_description}
                            featuresList={detail.features_list}
                            featuresImage={detail.features_image}
                        />
                        <TechnicalSection
                            schemaImage={detail.schema_image}
                            interactionsText={detail.interactions_text}
                            interactionsImage={detail.interactions_image}
                        />
                        <DocumentsSection 
                            documents={detail.documents} 
                            pricingInfo={detail.pricing_info}
                        />
                    </div>
                )}
        </>
    )
}

export default DetailProduct

